import { deleteContent, putContent, getLabels, getContent } from './confluence';
import { createTopicsFromLabels } from './topic';
import { createQuestionPutPayload } from '../payloads';

export const QUESTION_EXPANSIONS =
	'' +
	'operations,' +
	'space,' +
	'body.view,' +
	'body.atlas_doc_format,' +
	'history.createdBy,' +
	'history.lastUpdated.when,' +
	'version,' +
	'metadata.labels,' +
	'metadata.properties.atl_cq_votes,' +
	'metadata.properties.atl_cq_accepted_answer,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.container,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.metadata.properties.atl_cq_votes,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.metadata.properties.atl_cq_accepted_answer,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.operations,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.body.view,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.body.atlas_doc_format,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.history,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.version,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.children.comment.body.view,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.children.comment.body.atlas_doc_format,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.children.comment.operations,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.children.comment.history,' +
	'children.ac__com_atlassian_confluence_plugins_confluence_questions__answer.children.comment.version,' +
	'children.comment.body.view,' +
	'children.comment.body.atlas_doc_format,' +
	'children.comment.operations,' +
	'children.comment.history,' +
	'children.comment.version';

export const putQuestion = (id, title, body, labels, versionNumber, spaceKey) => {
	let oldAndNewLabels = [];
	return getLabels(id)
		.then((labelResult) => {
			const oldLabels = labelResult.results.map((label) => label.name);
			const newLabels = labels.map((label) => label.name);
			// Set used to ensure there is no duplicated labels.
			oldAndNewLabels = new Set([...oldLabels, ...newLabels]);
			return putContent(id, createQuestionPutPayload(spaceKey, title, body, versionNumber, labels));
		})
		.then(() => createTopicsFromLabels([...oldAndNewLabels]));
};

export const deleteQuestion = (id) => deleteContent(id);
export const getQuestion = (id) => getContent(id, { expand: QUESTION_EXPANSIONS });
